import angular from 'angular';

let moduleName = 'confirmation';
angular
  .module(moduleName, [])
  .controller('ConfirmationController', ConfirmationController)
  .controller('InformationDialogController', InformationDialogController)
  .factory('ConfirmationFactory', ConfirmationFactory);

ConfirmationController.$inject = ['$translate','$scope','$uibModalInstance','text'];
function ConfirmationController($translate,$scope,$uibModalInstance,text) {
  $scope.text = $translate.instant(text);
  $scope.ok = ok;
  $scope.cancel = cancel;

  function ok() {
    $uibModalInstance.close('ok');
  }

  function cancel() {
    $uibModalInstance.dismiss('cancel');
  }
}

InformationDialogController.$inject = ['$translate', '$scope', '$uibModalInstance', 'text'];
function InformationDialogController($translate, $scope, $uibModalInstance, text) {
  $scope.text = $translate.instant(text);
  $scope.ok = ok;

  function ok() {
    $uibModalInstance.close('ok');
  }
}


ConfirmationFactory.$inject = ['$mdDialog', '$translate'];
function ConfirmationFactory($mdDialog, $translate) {
  
  return {
    materialConfirmDialogWithoutCancel: function(textKey, textParams, okTextKey, okTextParams) {
      return this.genericMaterialConfirmDialog(textKey, textParams, okTextKey, okTextParams, null, null, true, false)
    },

    materialConfirmDialog: function(textKey, textParams, okTextKey, okTextParams, cancelTextKey, cancelTextParams, isCancelButtonHidden = false) {
      return this.genericMaterialConfirmDialog(textKey, textParams, okTextKey, okTextParams, cancelTextKey, cancelTextParams, isCancelButtonHidden, false)
    },

    htmlMaterialConfirmDialog: function(textKey, textParams, okTextKey, okTextParams, cancelTextKey, cancelTextParams, isCancelButtonHidden = false, cssClasses = []) {
      return this.genericMaterialConfirmDialog(textKey, textParams, okTextKey, okTextParams, cancelTextKey, cancelTextParams, isCancelButtonHidden, true, cssClasses)
    },
  
    genericMaterialConfirmDialog: function(textKey, textParams, okTextKey, okTextParams, cancelTextKey, cancelTextParams, isCancelButtonHidden, isHtmlConfirmationDialog, cssClasses) {
      const text = $translate.instant(textKey, textParams);
      const okText = okTextKey ? $translate.instant(okTextKey, okTextParams) : $translate.instant('form/ok');
      const cancelText = cancelTextKey ? $translate.instant(cancelTextKey, cancelTextParams) : $translate.instant('cancel');

      return $mdDialog.show({

        multiple: true,
        
        template: require('./confirmation-material.dialog.html'),
        clickOutsideToClose: true,
        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
          
          $scope.text = text;
          $scope.okText = okText;
          $scope.cancelText = cancelText;
          $scope.isCancelButtonHidden = isCancelButtonHidden;
          $scope.isHtmlConfirmationDialog = isHtmlConfirmationDialog;
          $scope.cssClasses = cssClasses;

          $scope.ok = function() {
            $mdDialog.hide();
          };
          $scope.cancel = function() {
            $mdDialog.cancel();
          };
        }]
      });
    }
  }
}

export default moduleName;
